import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="privacy">
      <Header />
      <main role="main" id="MainContent" tabIndex={-1}>
        <div
          id="shopify-section-template--19428125016138__main_page_8hEqeK"
          className="shopify-section"
        >
          <div className="page-width">
            <div className="page-width__inner">
              <h1 className="main-page__header">Privacy Policy</h1>
              <div className="main-page">
                <div className="main-page__content prose is-page ">
                  <div className="wrapper">
                    <div className="grid">
                      <p>&nbsp;</p>
                    </div>
                    <p>
                      The abridged version is that we take your privacy
                      seriously. The more “professional” and
                      detailed&nbsp;policy&nbsp;is as follows:
                    </p>
                    <p>&nbsp;</p>
                    <p style={{ textAlign: "center" }}>
                      <strong>Mindredlane Inc. Privacy Policy</strong>
                    </p>
                    <p style={{ textAlign: "center" }}>
                      <strong>Last Updated 6-9-2023</strong>
                    </p>
                    <p>
                      Welcome to the web site (the “Site”) of Mindredlane, Inc.
                      (“Mindredlane”, “we”, “us” and/or “our”). This Site is
                      operated by Mindredlane and has been created to provide
                      information about our company and its creative
                      collaboration services (the “Services”) to our users
                      (“you”, “your”). This Privacy Policy sets forth Marine
                      Layer’s policy with respect to information including
                      personally identifiable data (“Personal Data” or “Personal
                      Information”) and other information that is collected from
                      Site visitors and users of the Services. If you are a
                      resident of United States of America (U.S.A), please see
                      the Rights of U.S.A. Residents section below. If you are a
                      resident of the European Union, please see the Rights
                      European Union Residents section below. Any terms defined
                      in the California Consumer Privacy Act (the “CCPA”) (Cal.
                      Civ. Code Section 1798.140) have the same meaning when
                      used in the Rights Under the California Consumer Privacy
                      Act (the “CCPA”) section.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Personal Information Collected:</strong>
                    </p>
                    <p>
                      We collect Personal Data from you when you voluntarily
                      provide such information such as when you register for
                      access to the Services, use certain Services, contact us
                      with inquiries or respond to one of our surveys.
                    </p>
                    <p>
                      By voluntarily providing us with Personal Data by using
                      our website and our services, you understand that your
                      data is being used in accordance with this Privacy Policy.
                      If you provide Personal Data, you acknowledge and agree
                      that such Personal Data may be transferred from your
                      current location to the offices and servers of Marine
                      Layer and the authorized third parties
                    </p>
                    <p>
                      Non-Identifiable or Aggregated Data: When you interact
                      with Mindredlane through the Site or Services, we receive
                      and store certain personally non-identifiable information.
                      Such information, which is collected passively using
                      various technologies, cannot presently be used to
                      specifically identify you. Mindredlane may store such
                      information itself or such information may be included in
                      databases owned and maintained by Mindredlane affiliates,
                      agents or service providers. This Site may use such
                      information and pool it with other information to track,
                      for example, the total number of visitors to our Site, the
                      number of visitors to each page of our Site, the domain
                      names of our visitors' Internet service providers, and how
                      our users use and interact with the Mindredlane Service.
                      &nbsp;Also, in an ongoing effort to better understand and
                      serve the users of the Services, Mindredlane often
                      conducts research on its customer demographics, interests
                      and behavior based on the Personal Data and other
                      information provided to us. This research may be compiled
                      and analyzed on an aggregate basis. Mindredlane may share
                      this non-identifiable and aggregate data with its
                      affiliates, agents and business partners, but this type of
                      non-identifiable and aggregate information does not
                      identify you personally. Mindredlane may also disclose
                      aggregated user statistics in order to describe our
                      services to current and prospective business partners, and
                      to other third parties for other lawful purposes.
                    </p>
                    <p>
                      When you visit the Site, we automatically collect certain
                      information about your device, including information about
                      your web browser, IP address, time zone, and some of the
                      cookies that are installed on your device. Additionally,
                      as you browse the Site, we collect information about the
                      individual web pages or products that you view, what
                      websites or search terms referred you to the Site, and
                      information about how you interact with the Site. We refer
                      to this automatically-collected information as “Device
                      Information.”
                    </p>
                    <p>
                      We collect Device Information using the following
                      technologies:
                    </p>
                    <p>
                      &nbsp;&nbsp;&nbsp;- “Cookies” are data files that are
                      placed on your device or computer and often include an
                      anonymous unique identifier. For more information about
                      cookies, and how to disable cookies, visit
                      http://www.allaboutcookies.org.
                    </p>
                    <p>
                      &nbsp;&nbsp;&nbsp;- “Log files” track actions occurring on
                      the Site, and collect data including your IP address,
                      browser type, Internet service provider, referring/exit
                      pages, and date/time stamps.
                    </p>
                    <p>
                      &nbsp;&nbsp;&nbsp;- “Web beacons,” “tags,” and “pixels”
                      are electronic files used to record information about how
                      you browse the Site.
                    </p>
                    <p>
                      Additionally when you make a purchase or attempt to make a
                      purchase through the Site, we collect certain information
                      from you, including your name, billing address, shipping
                      address, payment information (including credit card
                      numbers, PayPal or Apple Pay information), email address,
                      and phone number. &nbsp;We refer to this information as
                      “Order Information.”
                    </p>
                    <p>
                      We may also collect offline data, data of your purchases
                      in our stores as well as third-party lists for direct
                      mail.
                    </p>
                    <p>
                      As used in this Privacy Policy, “Personal Information” and
                      “Personal Data” include information used to identify or
                      contact you in addition to Device information or Order
                      information. Please note, however, as used in the Rights
                      Under the California Consumer Privacy Act (the “CCPA”)
                      section, “personal information” has the same meaning as
                      defined in the CCPA. Additionally, as used in the Rights
                      of European Union Residents section, “personal
                      information” has the same meaning as personal data as
                      defined in the GDPR.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>How Your Information is Used:</strong>
                    </p>
                    <p>
                      We use the Order Information that we collect generally to
                      fulfill any orders placed through the Site (including
                      processing your payment information, arranging for
                      shipping, and providing you with invoices and/or order
                      confirmations). &nbsp;Additionally, we use this Order
                      Information to:
                    </p>
                    <p>Communicate with you;</p>
                    <p>Screen our orders for potential risk or fraud; and</p>
                    <p>
                      Based on your preferences as indicated through past
                      purchases, searches and other activity, provide you with
                      information or advertising relating to our products or
                      services.
                    </p>
                    <p>
                      We use the Device Information that we collect to help us
                      screen for potential risk and fraud (in particular, your
                      internet protocol IP address), and more generally to
                      improve and optimize our Site (for example, by generating
                      analytics about how our customers browse and interact with
                      the Site, and to assess the success of our marketing and
                      advertising campaigns).
                    </p>
                    <p>
                      We collect cookies and pixels on our website that may
                      allow us to collect your email address through the use of
                      trusted third party partners. These partners may also
                      combine your email information with other information they
                      have access to such as mailing address so that Marine
                      Layer may serve relevant marketing offers to you via email
                      and direct mail. If you do not want Mindredlane to collect
                      such information about you, please contact
                      works@mindredlane.watch to opt out.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Sharing Personal Information:</strong>
                    </p>
                    <p>
                      We share your Personal Information with third parties to
                      help us use your Personal Information, as described above.
                      &nbsp;For example, we use Shopify to power our online
                      store--you can read more about how Shopify uses your
                      Personal Information here: &nbsp;Privacy. We also use
                      Google Analytics to help us understand how our customers
                      use the Site--you can read more about how Google uses your
                      Personal Information here: &nbsp;Privacy. You can also
                      opt-out of Google Analytics here:&nbsp;
                      <Link onClick={toTop} to="/">
                        Home
                      </Link>
                      .
                    </p>
                    <p>
                      We consider your information to be a vital part of our
                      relationship with you and therefore strive to limit its
                      disclosure outside Mindredlane. There are, however,
                      certain circumstances in which we may share your Personal
                      Information with certain third parties without further
                      notice to you, as set forth below:
                    </p>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Business
                      Transfers: As we develop our business, we might sell or
                      buy businesses or assets. In the event of a corporate
                      sale, merger, reorganization, dissolution or similar
                      event, Personal Data may be part of the transferred
                      assets. Our investors may also have access to certain
                      personal data as it pertains their rights as investors.
                    </p>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Agents,
                      Consultants and Related Third Parties: Mindredlane, like
                      many businesses, sometimes hires other companies to
                      perform certain business-related functions. Examples of
                      such functions include mailing information, maintaining
                      databases and processing payments. When we employ another
                      company to perform a function of this nature, we only
                      provide them with the information that they need to
                      perform their specific function.
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </p>
                    <p>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Legal
                      Requirements: Mindredlane may disclose your Personal Data
                      if required to do so by law or in the good faith belief
                      that such action is necessary to (i) comply with a legal
                      obligation, (ii) protect and defend the rights or property
                      of Mindredlane, (iii) act in urgent circumstances to
                      protect the personal safety of users of the Site or the
                      public, or (iv) protect against legal liability.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Behavioral Advertising:</strong>
                    </p>
                    <p>
                      &nbsp;As described above, we use your Personal Information
                      to provide you with targeted advertisements or marketing
                      communications we believe may be of interest to you.
                      &nbsp;For more information about how targeted advertising
                      works, you can visit the Network Advertising Initiative’s
                      (“NAI”) educational page at
                      http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.
                    </p>

                    <p>&nbsp;</p>
                    <p>
                      Additionally, you can opt out of some of these services by
                      visiting the Digital Advertising Alliance’s opt-out portal
                      at: &nbsp;http://optout.aboutads.info/.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Do Not Track Signals:</strong>
                    </p>
                    <p>
                      Please note that we do not alter our Site’s data
                      collection and use practices when we see a Do Not Track
                      signal from your browser.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>&nbsp;Rights of U.S.A. Residents:</strong>
                    </p>
                    <p>
                      <em>
                        Rights Regarding Personal Information Used For Marketing
                      </em>
                    </p>
                    <p>
                      California law permits California residents to request
                      information regarding our disclosure of personal
                      information to third parties for those third parties’
                      marketing purposes. As permitted under California law, in
                      lieu of providing this information, we have adopted a
                      policy of permitting you to opt-out of such disclosures of
                      personal information. Once your opt-out request is
                      processed, we will not disclose your personal information
                      to third parties for those third parties’ marketing
                      purposes. To opt-out, please contact&nbsp;
                      <Link onClick={toTop} to="mailto:works@mindredlane.watch">
                        works@mindredlane.watch
                      </Link>
                      .
                    </p>
                    <p>
                      Starting November 3, 2021, Mindredlane will extend the
                      rights granted to California residents per California law
                      to all U.S.A. residents. We share personal data with third
                      party marketing partners for commercial purposes. We offer
                      for all U.S.A. residents the same opt-out disclosures for
                      personal information with the process we follow in
                      accordance with California Law.
                    </p>
                    <p>
                      <em>
                        Rights Under the California Consumer Privacy Act (the
                        “CCPA”)
                      </em>
                    </p>
                    <p>
                      California law requires businesses to disclose information
                      regarding the rights of California residents pursuant to
                      the CCPA. Any terms defined in the CCPA (Cal. Civ. Code
                      Section 1798.140) have the same meaning when used in this
                      section.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      All U.S.A. residents may request that we disclose to you
                      the following information covering the preceding 12
                      months:
                    </p>
                    <p>
                      (1) The categories of personal information we have
                      collected about you;
                    </p>
                    <p>
                      (2) The categories of sources from which the personal
                      information was collected;
                    </p>
                    <p>
                      (3) The business or commercial purpose for collecting or
                      selling personal information;
                    </p>
                    <p>
                      (4) The categories of third parties with which we share
                      personal information;
                    </p>
                    <p>
                      (5) The categories of personal information about you that
                      we have sold and the categories of third parties to which
                      the personal information was sold;
                    </p>
                    <p>
                      (6) The categories of personal information about you that
                      we have disclosed for a business purpose and the
                      categories of third parties to which the personal
                      information was disclosed;
                    </p>
                    <p>
                      (7) The specific pieces of personal information we have
                      collected about you.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      You may request the disclosure of the information listed
                      above by calling (844) 544-5199 or submitting a request at
                    </p>
                    <p>
                      <Link onClick={toTop} to="/">
                        Home
                      </Link>
                      . Such a request may be referred to as a right to know
                      request. Pursuant to California law, we will verify your
                      identity before complying with any such request.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      You have the right to request that we delete any personal
                      information about you that we have collected from you, and
                      that we direct any service provider to delete such
                      personal information from its records. Such a request may
                      be referred to as a request to delete. However, pursuant
                      to the CCPA, your information may not be deleted under
                      certain circumstances, including where maintenance of your
                      personal information is necessary to: complete the
                      transaction for which the personal information was
                      collected, fulfill the terms of a written warranty or
                      product recall conducted in accordance with federal law,
                      to provide a good or service that you requested or that is
                      reasonably anticipated within the context of your ongoing
                      business relationship with us, or to otherwise perform a
                      contract between us and you; to detect security incidents,
                      protect against or prosecute fraudulent or illegal
                      activity; to enable solely internal uses that are
                      reasonably aligned with your expectations based on your
                      relationship with us; to comply with a legal obligation;
                      or to otherwise use your information internally in a
                      lawful manner that is compatible with the context in which
                      you provided the information. For more information about
                      these and other situations in which we may not delete your
                      information, please see Cal. Civ. Code Section
                      1798.105(d).
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      You may request the deletion of your information by
                      calling (844) 544-5199 or submitting a request at
                    </p>
                    <p>
                      <Link onClick={toTop} to="/">
                        Home
                      </Link>
                      . Before deleting your personal information, we will
                      verify your identity, as required by the CCPA.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      You may use an authorized agent to submit a right to know
                      request or a request to delete. To use an authorized
                      agent, you must provide the agent with written
                      authorization. In addition, you may be required to verify
                      your own identity with us. We may deny a request from an
                      agent that does not submit proof that they have been
                      authorized by you act on your behalf. Such requirements,
                      however, will not apply where you have provided the agent
                      with power of attorney pursuant to Cal. Prob. Code
                      Sections 4000 to 4465.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      You have the right, at any time, to direct us not to sell
                      your personal information. This right may be referred to
                      as the right to opt-out. You may opt out of the sale of
                      your personal information at a dedicated webpage entitled
                      “Do Not Sell My Personal Information” on
                    </p>
                    <p>
                      <Link onClick={toTop} to="/">
                        Home
                      </Link>
                      &nbsp;or by calling (844) 544-5199. If we have a good
                      faith, reasonable, and documented belief that a request to
                      opt-out is fraudulent, we may deny the request. You may
                      use an authorized agent to submit a request to opt-out on
                      your behalf. To do so, you must provide the agent with
                      written authorization. We may deny a request from an agent
                      that does not submit proof that they have been authorized
                      by you to act on your behalf.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      In addition, we do not and will not sell the personal
                      information of minors we have actual knowledge are under
                      the age of 16 without affirmative authorization (known as
                      “opt-in”).
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      In the preceding 12 months, we have collected the
                      following categories of personal information about U.S.A
                      residents from the following sources and for the following
                      purposes. The CCPA requires that we refer to specific
                      categories of personal information enumerated in the CCPA.
                      We may collect only certain pieces of personal information
                      described in a given category and may not collect certain
                      pieces of personal information described in each category.
                    </p>
                    <p>&nbsp;</p>
                    <table width={536}>
                      <tbody>
                        <tr>
                          <td width={108}>
                            <p>
                              <em>
                                Category of Personal Information Collected
                              </em>
                            </p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                Personal Information Mindredlane collects in
                                Each Category
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              <em>Category of Source of Collection</em>
                            </p>
                          </td>
                          <td width={113}>
                            <p>
                              <em>
                                Business or Commercial Purpose of Collection
                              </em>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>
                              Identifiers such as a real name, alias, postal
                              address, unique personal identifier, online
                              identifier, internet protocol address, email
                              address, account name, social security number,
                              driver's license number, passport number, or other
                              similar identifiers.
                            </p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                Full Name, Email address, Mailing address, Phone
                                Number
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information from U.S.A. residents
                              online, in-store and through customer service. We
                              also collect this information from 3<sup>rd</sup>
                              &nbsp;party marketing providers.
                            </p>
                          </td>
                          <td width={113}>
                            <p>
                              Processing customer requests and transactions;
                              customer service support, fraud, safety and
                              security; marketing
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>
                              Categories of personal information described in
                              subdivision (e) of Cal. Civ. Code Section 1798.80.
                            </p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                Full Name, Email address, Mailing address, Phone
                                Number
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information from U.S.A. residents
                              online, in-store and through customer service. We
                              also collect this information from 3<sup>rd</sup>
                              &nbsp;party marketing providers.
                            </p>
                          </td>
                          <td width={113}>
                            <p>
                              Processing customer requests and transactions;
                              customer service support, fraud, safety and
                              security; marketing
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>
                              Commercial information, including records of
                              personal property, products or services purchased,
                              obtained, or considered, or other purchasing or
                              consuming histories or tendencies.
                            </p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                First Date of purchase, most recent purchase,
                                Store location of first purchase, items
                                purchased
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information from U.S.A. residents
                              online, in-store and through customer service. We
                              also collect this information from 3<sup>rd</sup>
                              &nbsp;party marketing providers.
                            </p>
                          </td>
                          <td width={113}>
                            <p>
                              Processing customer requests and transactions;
                              fraud, safety and security; marketing
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>Biometric Information</p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                Customer photos submitted through customer
                                service or Social Media&nbsp;
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information from U.S.A. residents
                              through social media or customer service emails.
                            </p>
                          </td>
                          <td width={113}>
                            <p>Customer service support, marketing</p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>
                              Internet or other electronic network activity
                              information, including, but not limited to,
                              browsing history, search history, and information
                              regarding a consumer's interaction with an
                              internet website, application, or advertisement.
                            </p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                Browsing history or email and SMS click-through
                                behavior
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information from U.S.A. residents
                              online.
                            </p>
                          </td>
                          <td width={113}>
                            <p>
                              Processing customer requests and transactions;
                              fraud, safety and security; marketing
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>Geolocation Data</p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                IP address geolocation, customer mailing address
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information from U.S.A. residents
                              online.
                            </p>
                          </td>
                          <td width={113}>
                            <p>
                              Processing customer requests and transactions;
                              customer service support, fraud, safety and
                              security; marketing
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>
                              Audio, electronic, visual, thermal, olfactory, or
                              similar information.
                            </p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>Voicemails sent to customer service</em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information from U.S.A. residents
                              online, in-store and through customer service. We
                              also collect this information from 3<sup>rd</sup>
                              &nbsp;party marketing providers.
                            </p>
                          </td>
                          <td width={113}>
                            <p>
                              Processing customer requests and transactions;
                              customer service support, fraud, safety and
                              security; marketing
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={108}>
                            <p>
                              Inferences drawn from any of the information
                              identified in Cal. Civ. Code Section
                              1798.140(o)(1) to create a profile about a
                              consumer reflecting the consumer's preferences,
                              characteristics, psychological trends,
                              predispositions, behavior, attitudes,
                              intelligence, abilities, and aptitudes.
                            </p>
                          </td>
                          <td width={108}>
                            <p>
                              <em>
                                Consumer buying profiles that suggest marketing
                                interests
                              </em>
                            </p>
                          </td>
                          <td width={122}>
                            <p>
                              We collect this information directly from U.S.A.
                              residents both online and in-store; we also
                              collect this information from 3<sup>rd</sup>
                              &nbsp;party marketing providers
                            </p>
                          </td>
                          <td width={113}>
                            <p>Marketing</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>
                      In the preceding 12 months, we have sold the following
                      categories of personal information about U.S.A. residents
                      to the following categories of third parties.
                    </p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <table width={536}>
                      <tbody>
                        <tr>
                          <td width={151}>
                            <p>
                              <em>Category of Personal Information Sold</em>
                            </p>
                          </td>
                          <td width={268}>
                            <p>
                              <em>
                                Category of Third Party to Which Personal
                                Information Disclosed
                              </em>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={151}>
                            <p>Identifiers</p>
                          </td>
                          <td width={268}>
                            <p>Marketing providers</p>
                          </td>
                        </tr>
                        <tr>
                          <td width={151}>
                            <p>
                              Categories of personal information described in
                              subdivision (e) of Cal. Civ. Code Section 1798.80.
                            </p>
                          </td>
                          <td width={268}>
                            <p>Marketing providers</p>
                          </td>
                        </tr>
                        <tr>
                          <td width={151}>
                            <p>Commercial information</p>
                          </td>
                          <td width={268}>
                            <p>Marketing providers</p>
                          </td>
                        </tr>
                        <tr>
                          <td width={151}>
                            <p>
                              Internet or other electronic network activity
                              information
                            </p>
                          </td>
                          <td width={268}>
                            <p>Marketing providers</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <p>
                      In the preceding 12 months, we have disclosed for a
                      business purpose the following categories of personal
                      information about U.S.A. residents to the following
                      categories of third parties (to the extent the disclosure
                      was made to a third party).
                    </p>
                    <p>&nbsp;</p>
                    <table width={536}>
                      <tbody>
                        <tr>
                          <td width={167}>
                            <p>
                              <em>
                                Category of Personal Information Disclosed for a
                                Business Purpose
                              </em>
                            </p>
                          </td>
                          <td width={243}>
                            <p>
                              <em>
                                Category of Third Party to Which Personal
                                Information Disclosed, To The Extent Disclosed
                                To a Third Party
                              </em>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={167}>
                            <p>Identifiers</p>
                          </td>
                          <td width={243}>
                            <p>
                              Marketing providers; delivery service providers;
                              analytics providers; anti-fraud provider
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={167}>
                            <p>
                              Categories of personal information described in
                              subdivision (e) of Cal. Civ. Code Section 1798.80.
                            </p>
                          </td>
                          <td width={243}>
                            <p>
                              Marketing providers; delivery service providers;
                              analytics providers; anti-fraud provider
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={167}>
                            <p>Commercial information</p>
                          </td>
                          <td width={243}>
                            <p>Marketing providers; analytics providers;</p>
                          </td>
                        </tr>
                        <tr>
                          <td width={167}>
                            <p>
                              Internet or other electronic network activity
                              information
                            </p>
                          </td>
                          <td width={243}>
                            <p>
                              Marketing providers; analytics providers;
                              anti-fraud provider
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width={167}>
                            <p>
                              Inferences drawn from any of the information
                              identified in Cal. Civ. Code Section
                              1798.140(o)(1) to create a profile about a
                              consumer reflecting the consumer's preferences,
                              characteristics, psychological trends,
                              predispositions, behavior, attitudes,
                              intelligence, abilities, and aptitudes.
                            </p>
                          </td>
                          <td width={243}>
                            <p>Marketing providers; analytics providers</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>
                      We will not discriminate against you because you exercised
                      any of your rights under this section, including, but not
                      limited to, by:
                    </p>
                    <p>&nbsp;(1) Denying goods or services to you;</p>
                    <p>
                      (2) Charging different prices or rates for goods or
                      services, including through the use of discounts or other
                      benefits or imposing penalties;
                    </p>
                    <p>
                      (3) Providing a different level or quality of goods or
                      services to you;
                    </p>
                    <p>
                      (4) Suggesting that you will receive a different price or
                      rate for goods or services or a different level or quality
                      of goods or services.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      However, we may charge you a different price or rate, or
                      provide a different level or quality of goods or services,
                      if that difference is reasonably related to the value
                      provided to us by your data. In addition, we may offer
                      financial incentives, including payments to you as
                      compensation, for the collection of personal information,
                      the sale of personal information, or the deletion of
                      personal information. We may also offer a different price,
                      rate, level, or quality of goods or services to you if
                      that price or difference is directly related to the value
                      provided to us by your data. We will not use financial
                      incentive practices that are unjust, unreasonable,
                      coercive, or usurious in nature.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Rights of European Union Residents:</strong>
                    </p>
                    <p>
                      If you are a European Union resident, you have the right
                      to access personal information we hold about you and to
                      ask that your personal information be corrected, updated,
                      or deleted. As used in this section, personal information
                      has the same meaning as personal data as defined in the
                      GDPR. If you would like to exercise this right, please
                      contact us through the contact information below.
                    </p>
                    <p>
                      Additionally, if you are a European Union resident we note
                      that we are processing your information in order to
                      fulfill contracts we might have with you (for example if
                      you make an order through the Site), or otherwise to
                      pursue our legitimate business interests listed above.
                      &nbsp;Additionally, please note that your information will
                      be transferred outside of Europe, including to the United
                      States and Canada.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Data Retention:</strong>
                    </p>
                    <p>
                      When you place an order through the Site, we will maintain
                      your Order Information for our records unless and until,
                      if you are a U.S.A. or European Union resident, you ask us
                      to delete this information.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Children:</strong>
                    </p>
                    <p>
                      Mindredlane does not knowingly collect Personal Data from
                      children under the age of 13. If you are under the age of
                      13, please do not submit any Personal Data through the
                      Site. We encourage parents and legal guardians to monitor
                      their children’s Internet usage and to help enforce our
                      Privacy Policy by instructing their children never to
                      provide Personal Data on this Site without their
                      permission. If you have reason to believe that a child
                      under the age of 13 has provided Personal Data to Marine
                      Layer through this Site, please contact us, and we will
                      endeavor to delete that information from our databases.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Links to Other Web Sites:</strong>
                    </p>
                    <p>
                      This Privacy Policy applies only to the Site. This Site
                      may contain links to other web sites not operated or
                      controlled by Mindredlane (the “Third Party Sites”). The
                      policies and procedures we described here do not apply to
                      the Third Party Sites. The links from this Site do not
                      imply that Mindredlane endorses or has reviewed the Third
                      Party Sites. We suggest contacting those sites directly
                      for information on their privacy policies.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Security:</strong>
                    </p>
                    <p>
                      Mindredlane has implemented and maintains reasonable
                      security procedures and practices appropriate to the
                      nature of the Personal Information to protect the Personal
                      Information from unauthorized access and exfiltration,
                      theft, or disclosure. However, no Internet, email or other
                      electronic transmission is ever fully secure or error
                      free, so you should take special care in deciding what
                      information you send to us in this way.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Other Terms and Conditions:</strong>
                    </p>
                    <p>
                      Your access to and use of this Site is subject to the
                      Terms of Service.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Changes to Mindredlane’s Privacy Policy:</strong>
                    </p>
                    <p>
                      The Site and our business may change from time to time. As
                      a result, at times it may be necessary for Mindredlane to
                      make changes to this Privacy Policy. Mindredlane reserves
                      the right to update or modify this Privacy Policy at any
                      time and from time to time. Non-material changes will take
                      effect without notice upon the posting of an updated
                      Privacy Policy. We will notify you of material changes to
                      this Privacy Policy, changes which affect the use or
                      disclosure of your Personal Information, by posting a
                      notice on our homepage or sending you an email. Please
                      review this policy periodically, and especially before you
                      provide any Personal Information. This Privacy Policy was
                      last updated on the date indicated above. Your continued
                      use of the Site after any changes or revisions to this
                      Privacy Policy shall indicate your agreement with the
                      terms of such revised Privacy Policy.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Contact Mindredlane:</strong>
                    </p>
                    <p>
                      For more information about our privacy practices, if you
                      have questions, or if you would like to make a complaint,
                      please contact us by e-mail at works@mindredlane.watch or
                      by mail using the details provided below:
                    </p>
                    <p>Mindredlane Customer Service</p>
                    <p>1572 California Street, San Francisco CA 94109</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <div className="grid" />
                    <div className="grid">
                      <p style={{ textAlign: "center" }}>&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <limespot />
      </main>

      <Footer />
    </div>
  );
}

export default Privacy;
